import React from 'react';
import Web3 from 'web3';
import { withRouter } from 'react-router-dom';

import MobileSwapOrderBox from '../../Components/MobileSwapOrderBox/MobileSwapOrderBox';
import { SupportedTokens, SwapContracts, SwapContractABI } from "../../Data/ContractData";

import "./mobilehome.css";


class MobileHome extends React.Component {

  /*
    tokenSelected
    0 : APIX
    1 : wDASH
    2 : wXZC

    searchLevel
    0: default
    1: from token fixed
    2: to token fixed
  */


  constructor(props) {
    super(props);

    this.state = {
      isMetamaskConnected: false,
      userAccount: "",

      searchLevel: 0,
      searchedSwapPair: 0,
      swapSearchResult: [],

      tokenSelected: [0, 1],
    }
  }

  web3 = null;

  tokenInfo = [
    {
      tokenName: "APIX",
      tokenIcon: "tokenicon_apix.svg"
    },
    {
      tokenName: "WETH",
      tokenIcon: "tokenicon_weth.svg"
    },
    {
      tokenName: "wDASH",
      tokenIcon: "tokenicon_dash.svg"
    },
    /*
    {
      tokenName: "wXZC",
      tokenIcon: "tokenicon_xzc.svg"
    },
    */
  ]

  renderSwapList = () => {
    if (this.state.swapSearchResult.length === 0) return null;

    let tmpSwapList = [];

    for (let i = 0; i < this.state.swapSearchResult.length; i++) {
      tmpSwapList.push(<MobileSwapOrderBox swapPair={this.state.searchedSwapPair} swapData={this.state.swapSearchResult[i]} />)
    }

    return tmpSwapList;
  }

  changeSearchLevel = (level, tokenSelection) => {
    this.setState({
      swapSearchResult: []
    })

    if (level === 0) {
      this.props.history.push("/");
      this.changeSelectedToken(0, 1);

      this.setState({
        searchLevel: level
      })
    }
    if (level === 1) {
      this.changeSelectedToken(0, tokenSelection);

      this.setState({
        searchLevel: level
      })
    }
    if (level === 2) {
      this.changeSelectedToken(1, tokenSelection);

      this.setState({
        searchLevel: level
      })

      this.searchPairMobile();
    }
  }

  searchSwap = async () => {
    let selectedSwapPair = 0;
    if (this.state.tokenSelected[0] == 0 && this.state.tokenSelected[1] == 1) selectedSwapPair = 0;
    if (this.state.tokenSelected[0] == 0 && this.state.tokenSelected[1] == 2) selectedSwapPair = 1;
    if (this.state.tokenSelected[0] == 1 && this.state.tokenSelected[1] == 0) selectedSwapPair = 2;
    if (this.state.tokenSelected[0] == 1 && this.state.tokenSelected[1] == 2) selectedSwapPair = 3;
    if (this.state.tokenSelected[0] == 2 && this.state.tokenSelected[1] == 0) selectedSwapPair = 4;
    if (this.state.tokenSelected[0] == 2 && this.state.tokenSelected[1] == 1) selectedSwapPair = 5;

    let selectedContract = new this.web3.eth.Contract(SwapContractABI, SwapContracts[selectedSwapPair].contractAddr);
    let swap_count = await selectedContract.methods.swapCount().call();

    let swapList = [];
    for (let i = 0; i < swap_count; i++) {
      swapList.push(await selectedContract.methods.SwapOrders(i).call());
    }

    this.setState({
      swapSearchResult: swapList,
      searchedSwapPair: selectedSwapPair
    })

    //console.log(this.state);

    this.props.history.push('/search/' + this.tokenInfo[this.state.tokenSelected[0]].tokenName + "-" + this.tokenInfo[this.state.tokenSelected[1]].tokenName)
  }
  applySwap = async () => {
    console.log(this.state);

    let selectedContract = new this.web3.eth.Contract(SwapContractABI, SwapContracts[this.state.searchedSwapPair].contractAddr);
    let swap_count = await selectedContract.methods.swapCount().call();

    let swapList = [];
    for (let i = 0; i < swap_count; i++) {
      swapList.push(await selectedContract.methods.SwapOrders(i).call());
    }

    this.setState({
      swapSearchResult: swapList,
    })

    this.props.history.push('/search/' + this.tokenInfo[this.state.tokenSelected[0]].tokenName + "-" + this.tokenInfo[this.state.tokenSelected[1]].tokenName)
  }


  searchPairMobile = () => {
    this.searchSwap();

    this.props.history.push('/search/' + this.tokenInfo[this.state.tokenSelected[0]].tokenName + "-" + this.tokenInfo[this.state.tokenSelected[1]].tokenName)
  }

  changeSelectedToken = (id, to) => {
    let tmp = this.state.tokenSelected;
    tmp[id] = to;

    this.setState({
      tokenSelected: tmp
    })
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);

    this.connectMetamask();

    let selectedSwapPair = -1;
    /*old
    if (this.props.match.params.pair === "APIX-wDASH") selectedSwapPair = 0;
    if (this.props.match.params.pair === "APIX-wXZC") selectedSwapPair = 1;
    if (this.props.match.params.pair === "wDASH-APIX") selectedSwapPair = 2;
    if (this.props.match.params.pair === "wDASH-wXZC") selectedSwapPair = 3;
    if (this.props.match.params.pair === "wXZC-APIX") selectedSwapPair = 4;
    if (this.props.match.params.pair === "wXZC-wDASH") selectedSwapPair = 5;
    */

    if (this.props.match.params.pair === "APIX-WETH") selectedSwapPair = 0;
    if (this.props.match.params.pair === "APIX-wDASH") selectedSwapPair = 1;
    if (this.props.match.params.pair === "WETH-APIX") selectedSwapPair = 2;
    if (this.props.match.params.pair === "WETH-wDASH") selectedSwapPair = 3;
    if (this.props.match.params.pair === "wDASH-APIX") selectedSwapPair = 4;
    if (this.props.match.params.pair === "wDASH-WETH") selectedSwapPair = 5;
    if (selectedSwapPair === -1) {

    } else {
      this.setState({
        searchLevel: 2,
        searchedSwapPair: selectedSwapPair
      })

      this.applySwap();
    }
  }

  connectMetamask = () => {
    try {
      this.web3 = new Web3(Web3.givenProvider);

      this.web3.eth.getAccounts()
        .then((result) => {
          this.setState({
            isMetamaskConnected: true,
            userAccount: result[0]
          })
        })
        .catch((err) => {
          this.setState({
            isMetamaskConnected: false,
            userAccount: ""
          })
        })
    } catch (err) {

    }
  }

  trimAddress = (addr) => {
    return String(addr).substring(0, 26);
  }

  renderMobileWalletBox = () => {
    if (!this.state.isMetamaskConnected) {
      return (
        <div className="APIS-m-app-div">
          <div className="APIS-m-app-div-1">
            <img className="APIS-m-app-icon-img" src={require("../../Asset/ic_wallet.svg")} />
          </div>
          <div className="APIS-m-app-div-2" onClick={this.connectMetamask()}>
            <p className="APIS-m-app-menutext">Connect Wallet</p>
          </div>
        </div>
      )
    } else {
      return (
        <div className="APIS-m-app-div-extended">
          <div className="APIS-m-app-div-1">
            <img className="APIS-m-app-icon-img-extended" src={require("../../Asset/ic_wallet.svg")} />
          </div>
          <div className="APIS-m-app-div-2">
            <p className="APIS-m-app-menutext-2">Wallet Connected</p>
            <p className="APIS-m-app-content">{this.trimAddress(this.state.userAccount)}...</p>
          </div>
        </div>
      )
    }
  }

  renderMobileSearchBox = () => {
    if (!this.state.isMetamaskConnected) {
      return (
        <div>
          <div className="APIS-m-app-div" onClick={() => { window.location.href = "https://itunes.apple.com/app/coinbase-wallet/id1278383455?ls=1&mt=8" }}>
            <div className="APIS-m-app-div-1">
              <img className="APIS-m-app-icon-img" src={require("../../Asset/coinbase_icon.png")} />
            </div>
            <div className="APIS-m-app-div-2">
              <p className="APIS-m-app-menutext">Install Coinbase Wallet</p>
            </div>
            <div className="APIS-m-app-div-3">
              <img className="APIS-m-app-arrow-img" src={require("../../Asset/ic_arrow.svg")} />
            </div>
          </div>
          <div className="APIS-m-app-div">
            <div className="APIS-m-app-div-1">
              <img className="APIS-m-app-icon-img" src={require("../../Asset/platform_logo.svg")} />
            </div>
            <div className="APIS-m-app-div-2" onClick={() => { window.location.href = "https://apis.mn" }}>
              <p className="APIS-m-app-menutext">Visit APIS Platform</p>
            </div>
            <div className="APIS-m-app-div-3">
              <img className="APIS-m-app-arrow-img" src={require("../../Asset/ic_arrow.svg")} />
            </div>
          </div>
        </div>
      )
    } else if (this.state.searchLevel === 0) {
      return (
        <div>
          <div className="APIS-m-app-div" onClick={() => { this.changeSearchLevel(1, 0) }}>
            <div className="APIS-m-app-div-1">
              <img className="APIS-m-app-icon-img" src={require("../../Asset/tokenicon_apix.svg")} />
            </div>
            <div className="APIS-m-app-div-2">
              <p className="APIS-m-app-menutext">APIX Swap Orders</p>
            </div>
            <div className="APIS-m-app-div-3">
              <img className="APIS-m-app-arrow-img" src={require("../../Asset/ic_arrow.svg")} />
            </div>
          </div>
          <div className="APIS-m-app-div" onClick={() => { this.changeSearchLevel(1, 1) }}>
            <div className="APIS-m-app-div-1">
              <img className="APIS-m-app-icon-img" src={require("../../Asset/tokenicon_weth.svg")} />
            </div>
            <div className="APIS-m-app-div-2">
              <p className="APIS-m-app-menutext">WETH Swap Orders</p>
            </div>
            <div className="APIS-m-app-div-3">
              <img className="APIS-m-app-arrow-img" src={require("../../Asset/ic_arrow.svg")} />
            </div>
          </div>
          <div className="APIS-m-app-div" onClick={() => { this.changeSearchLevel(1, 2) }}>
            <div className="APIS-m-app-div-1">
              <img className="APIS-m-app-icon-img" src={require("../../Asset/tokenicon_dash.svg")} />
            </div>
            <div className="APIS-m-app-div-2">
              <p className="APIS-m-app-menutext">wDASH Swap Orders</p>
            </div>
            <div className="APIS-m-app-div-3">
              <img className="APIS-m-app-arrow-img" src={require("../../Asset/ic_arrow.svg")} />
            </div>
          </div>
          <div className="APIS-m-app-div">
            <div className="APIS-m-app-div-1">
              <img className="APIS-m-app-icon-img" src={require("../../Asset/platform_logo.svg")} />
            </div>
            <div className="APIS-m-app-div-2" onClick={() => { window.location.href = "https://apis.mn" }}>
              <p className="APIS-m-app-menutext">Visit APIS Platform</p>
            </div>
            <div className="APIS-m-app-div-3">
              <img className="APIS-m-app-arrow-img" src={require("../../Asset/ic_arrow.svg")} />
            </div>
          </div>
        </div>
      )
    } else if (this.state.searchLevel === 1) {
      let tmpToTokens = [1, 2];
      if (this.state.tokenSelected[0] === 0) tmpToTokens = [1, 2]
      if (this.state.tokenSelected[0] === 1) tmpToTokens = [0, 2]
      if (this.state.tokenSelected[0] === 2) tmpToTokens = [0, 1]

      return (
        <div>
          <div className="APIS-m-app-div" onClick={() => { this.changeSearchLevel(0, 0) }}>
            <div className="APIS-m-app-div-1">
              <img className="APIS-m-app-icon-img" src={require("../../Asset/ic_home.svg")} />
            </div>

            <div className="APIS-m-app-div-2">
              <p className="APIS-m-app-menutext">Return to main page</p>
            </div>
          </div>
          <div className="APIS-m-app-div" onClick={() => { this.changeSearchLevel(2, tmpToTokens[0]) }}>
            <div className="APIS-m-app-div-1">
              <img className="APIS-m-app-icon-img-from" src={require("../../Asset/" + this.tokenInfo[this.state.tokenSelected[0]].tokenIcon)} />
              <img className="APIS-m-app-icon-img-to" src={require("../../Asset/" + this.tokenInfo[tmpToTokens[0]].tokenIcon)} />
            </div>
            <div className="APIS-m-app-div-2">
              <p className="APIS-m-app-menutext">{this.tokenInfo[this.state.tokenSelected[0]].tokenName}-{this.tokenInfo[tmpToTokens[0]].tokenName} Swap</p>
            </div>
            <div className="APIS-m-app-div-3">
              <img className="APIS-m-app-arrow-img" src={require("../../Asset/ic_arrow.svg")} />
            </div>
          </div>
          <div className="APIS-m-app-div" onClick={() => { this.changeSearchLevel(2, tmpToTokens[1]) }}>
            <div className="APIS-m-app-div-1">
              <img className="APIS-m-app-icon-img-from" src={require("../../Asset/" + this.tokenInfo[this.state.tokenSelected[0]].tokenIcon)} />
              <img className="APIS-m-app-icon-img-to" src={require("../../Asset/" + this.tokenInfo[tmpToTokens[1]].tokenIcon)} />
            </div>
            <div className="APIS-m-app-div-2">
              <p className="APIS-m-app-menutext">{this.tokenInfo[this.state.tokenSelected[0]].tokenName}-{this.tokenInfo[tmpToTokens[1]].tokenName} Swap</p>
            </div>
            <div className="APIS-m-app-div-3">
              <img className="APIS-m-app-arrow-img" src={require("../../Asset/ic_arrow.svg")} />
            </div>
          </div>
        </div>
      )
    } else if (this.state.searchLevel === 2) {
      return (
        <div>
          <div className="APIS-m-app-div" onClick={() => { this.changeSearchLevel(0, 0) }}>
            <div className="APIS-m-app-div-1">
              <img className="APIS-m-app-icon-img" src={require("../../Asset/ic_home.svg")} />
            </div>

            <div className="APIS-m-app-div-2">
              <p className="APIS-m-app-menutext">Return to main page</p>
            </div>
          </div>
          <div className="APIS-m-app-div">
            <div className="APIS-m-app-div-1">
              <img className="APIS-m-app-icon-img-from" src={require("../../Asset/" + this.tokenInfo[this.state.tokenSelected[0]].tokenIcon)} />
              <img className="APIS-m-app-icon-img-to" src={require("../../Asset/" + this.tokenInfo[this.state.tokenSelected[1]].tokenIcon)} />
            </div>
            <div className="APIS-m-app-div-2">
              <p className="APIS-m-app-menutext">{this.tokenInfo[this.state.tokenSelected[0]].tokenName}-{this.tokenInfo[this.state.tokenSelected[1]].tokenName} Swap List</p>
            </div>
          </div>
          {this.renderSwapList()}
        </div>
      )
    }
  }

  renderMobileSearchResult = () => {
    return null;
  }

  render() {
    return (
      <div className="APIS-m-swap">
        <div className="APIS-m-swap-topdiv">
          <div className="APIS-m-swap-topcontent">
            <div className="APIS-m-swap-intro">
              <div className="APIS-m-swap-intro-text">
                <h1 className="APIS-m-swap-intro-text-head">
                  <span className="APIS-m-swap-intro-text-bold">Fast</span> and <span className="APIS-m-swap-intro-text-bold">simple</span> way<br />
                  to <span className="APIS-m-swap-intro-text-bold">Swap</span> APIX &<br />ERC-20 Tokens
                </h1>
                <p className="APIS-m-swap-intro-text-noti">
                  Note: Creating, Taking swap on mobile is not supported.<br />
                  Use Coinbase Wallet to use our service on mobile devices.<br />
                  Also, you can use Desktop brower & Metamask, too.<br />
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="APIS-m-swap-centerdiv">
          <div className="APIS-m-swap-centercontent">
            <div className="APIS-m-app-list">
              {this.renderMobileWalletBox()}
              {this.renderMobileSearchBox()}
              {this.renderMobileSearchResult()}
            </div>
          </div>
        </div>

      </div>
    )
  }
}

export default withRouter(MobileHome);